import { render, staticRenderFns } from "./BaseCustomSelect.vue?vue&type=template&id=66019f1d&scoped=true"
import script from "./BaseCustomSelect.vue?vue&type=script&lang=js"
export * from "./BaseCustomSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseCustomSelect.vue?vue&type=style&index=0&id=66019f1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66019f1d",
  null
  
)

export default component.exports